// Client for /api/admin2 (JWT + is_admin, enforced server-side).
import { supabase } from '../lib/supabaseClient';

export async function callAdmin(action, params = {}) {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  if (!token) throw new Error('Please log in first.');

  const res = await fetch('/api/admin2', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ action, ...params }),
  });
  let json = null;
  try {
    json = await res.json();
  } catch {
    // non-JSON body — handled by the generic error below
  }
  if (!res.ok) throw new Error(json?.error || `Request failed (${res.status})`);
  return json;
}
